import { PulseLoader } from "react-spinners";

const override = {
  margin: "0 auto",
  position: "absolute",
  top: "20%",
  left: "50%",
  // transform: "translate(-50%, -50%)",
  borderColor: "#202946",
  zIndex: 9999, // Ensure spinner is on top
};

const SpinnerComponent = ({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent black overlay
            zIndex: 9998, // Ensure overlay is below spinner
          }}
        ></div>
      )}
      <PulseLoader
        color={"#202946"}
        loading={isLoading}
        cssOverride={override}
        size={30}
      />
    </>
  );
};

export default SpinnerComponent;
